export default function (context, {id}) {
    context.commit('form/clean');
    context.commit('loading', false);
    if (id) {
        context.state.title = 'Редактирование подарочного сертификата №' + id;
        context.dispatch('get', {
            id,
            cb: (data) => {
                let form = {
                    Id: data.Id,
                    Number: data.Number,
                    IssueDate: data.IssueDate.Serialized,
                    StartDate: data.StartDate.Serialized,
                    EndDate: data.EndDate.Serialized,
                    OwnerLegalEntityId: data.OwnerLegalEntityId,
                    CurrencyId: data.CurrencyId,
                    Type: data.Type,
                    IsPayed: data.IsPayed,
                    IsUsed: data.IsUsed,
                    Sum: data.Sum,
                    BankCommission: data.BankCommission,
                };
                if (data.ClientId) {
                    form.ContragentId = data.ClientId;
                    form.ContragentName = data.ClientName;
                    form.ContragentType = 'client';
                }
                if (data.PartnerId) {
                    form.ContragentId = data.PartnerId;
                    form.ContragentName = data.PartnerName;
                    form.ContragentType = 'partner';
                }
                if (data.PartnerLegalId) {
                    context.dispatch('get_legal', {PartnerId: data.PartnerId, id: data.PartnerLegalId});
                }
                context.commit('form/set', form);
            }
        })
    } else {
        context.state.title = 'Добавление подарочного сертификата';
    }
}
